module.exports = __webpack_public_path__ + "static/media/help-icon.3c071024.png";